import { render, staticRenderFns } from "./MarketMainIndustry.vue?vue&type=template&id=f54d493c&scoped=true"
import script from "./MarketMainIndustry.vue?vue&type=script&lang=js"
export * from "./MarketMainIndustry.vue?vue&type=script&lang=js"
import style0 from "./MarketMainIndustry.vue?vue&type=style&index=0&id=f54d493c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54d493c",
  null
  
)

export default component.exports